import { EditOperationTransformer, StringFileData } from "components/organisms/editor/core/model";

const api = {
    otType: "history-ot",
    trackChangesUserId: null,

    getText() {
        return this.snapshot.getContent({ filterTrackedDeletes: true });
    },

    getLength() {
        return this.snapshot.getStringLength();
    },
};

export const historyOTType = {
    api,

    transformX(ops1, ops2) {
        const left = [...ops1];
        const right = [...ops2];

        for (let i = 0; i < left.length; i += 1) {
            for (let j = 0; j < right.length; j += 1) {
                const [a, b] = EditOperationTransformer.transform(left[i], right[j]);
                left[i] = a;
                right[j] = b;
            }
        }

        return [left, right];
    },

    apply(snapshot, ops) {
        const afterFile = StringFileData.fromRaw(snapshot.toRaw());
        for (const op of ops) {
            afterFile.edit(op);
        }
        return afterFile;
    },

    compose(ops1, ops2) {
        const ops = [...ops1, ...ops2];
        let currentOp = ops.shift();

        if (currentOp === undefined) {
            return [];
        }

        const result = [];
        for (const op of ops) {
            if (currentOp.canBeComposedWith(op)) {
                currentOp = currentOp.compose(op);
            } else {
                result.push(currentOp);
                currentOp = op;
            }
        }

        result.push(currentOp);
        return result;
    },
};

export default historyOTType;
